(function ($) {
  Drupal.behaviors.howtolessons = {
    attach: function (context) {
      var $steps = $('.js-how-to-lesson-step', context);
      var $productGrids = $('.how_to-lesson__step-product-grid', $steps);

      // Show the product grid on clicking the CTA within the step
      $steps.each(function () {
        var $me = $(this);
        var $button = $('.js-button', $me);
        var $grid = $('.how-to-product-grid', $me);
        var $closeButton = $('.js-close', $me);

        // Once page has loaded slide up the grid, this is to allow proper widths and heights
        $grid.slideUp();
        $button.on('click', function (e) {
          // Find other grids in the steps
          // Close the ones that are not this
          e.preventDefault();
          var $carouselLength = $('.js-product-carousel').length;

          $(this).toggleClass('active').attr('aria-expanded', $this.attr('aria-expanded') === 'true' ? 'false' : 'true');
          $grid.slideToggle();
          if ($carouselLength > 1) {
            $('.js-product-carousel', $me)[0].slick.setPosition();
          }
          productGridHeights($me);
          $productGrids.not($grid).stop(true, true).hide();
          $('html, body').animate({
            scrollTop: $grid.offset().top - 150
          }, 500);
          $('.js-button.active', $steps).not($(this)).removeClass('active');
        });

        $closeButton.on('click', function (e) {
          $button.trigger('click');
          $button.focus();
        });

        // Keydown for close button
        $closeButton.on('keydown', function (e) {
          if (site.getKeycode(e) === 13) {
            $(this).trigger('click');
          }
        });
      });

      // Find the product grid, match their heights
      function productGridHeights($elem) {
        $('.product-grid__item', $elem).matchHeight();
      }
    }
  };
})(jQuery);
